import { getUrlParameter } from '../../general/functions';
import { BASE_URL } from '../../general/variables';
import { initTimePicker } from './function';

/** Form Validation */
const formAddSeminar = document.getElementById('formAddSeminar');
const postSeminarValidation = formAddSeminar
  ? FormValidation.formValidation(formAddSeminar, {
      fields: {
        seminarTitle: {
          validators: {
            notEmpty: {
              message: 'Title cannot be empty',
            },
          },
        },
        seminarSession: {
          validators: {
            notEmpty: {
              message: 'Please select seminar session',
            },
          },
        },
        seminarTime: {
          validators: {
            notEmpty: {
              message: 'Please select start time',
            },
          },
        },
      },
      plugins: {
        trigger: new FormValidation.plugins.Trigger(),
        excluded: new FormValidation.plugins.Excluded(),
        bootstrap: new FormValidation.plugins.Bootstrap(),
      },
    })
  : null;

/** Init datatable */

// Subtable
const consultationSubtable = (e) => {
  $('<div/>')
    .attr('id', 'child_data_ajax_' + $(e.currentTarget).attr('data-value'))
    .appendTo(e.detailCell)
    .KTDatatable({
      data: {
        type: 'remote',
        source: {
          read: {
            url: BASE_URL + 'Expo/getConsultationDetails',
            params: {
              uni: $(e.currentTarget).attr('data-value'),
              id: getUrlParameter('id'),
            },
          },
        },
        pageSize: 5,
        serverPaging: false,
        serverFiltering: false,
        serverSorting: false,
      },
      layout: {
        scroll: false,
        footer: false,
        spinner: {
          type: 1,
          theme: 'default',
        },
      },
      pagination: true,
      sortable: true,
      columns: [
        {
          field: 'NAME',
          title: 'Student',
          width: 240,
          template: function (row) {
            if (row.STATUS === null) {
              return `<span class="font-weight-bolder text-dark text-hover-primary font-size-sm">
                      ${row.NAME}
                    </span><br/>
                    <span class="font-size-sm">
                          ${row.ASSIGNED_COUNSELLOR === null || row.ASSIGNED_COUNSELLOR === 'NONE' ? 'Unhandled' : 'Handled By'} 
                          ${row.ASSIGNED_COUNSELLOR === null || row.ASSIGNED_COUNSELLOR === 'NONE' ? '' : row.ASSIGNED_COUNSELLOR}
                    </span>`;
            } else {
              const statObj = {
                class: null,
                text: null,
              };

              switch (row.STATUS) {
                case 'ACTIVE':
                  statObj.text = 'ACTIVE';
                  statObj.class = ' label-light-success';
                  break;

                case 'INACTIVE':
                case 'CANCEL':
                  statObj.text = 'INACTIVE';
                  statObj.class = ' label-light-danger';
                  break;

                case 'CLOSED':
                case 'COMPLETE':
                  statObj.text = 'CLOSED';
                  statObj.class = ' label-light-warning';
                  break;

                case 'FINISHED':
                  statObj.text = 'FINISHED';
                  statObj.class = ' label-light-info';
                  break;

                case 'OPEN':
                  statObj.text = 'OPEN';
                  statObj.class = ' ';
                  break;
              }

              return `<a class="font-weight-bolder text-dark text-hover-primary font-size-sm" href="${row.STATUS != null ? BASE_URL + 'detail_student?id=' + row.ID : '#'}">
                      ${row.NAME} <span class="ml-3 label label-sm font-weight-bold ${statObj.class} label-inline" > ${statObj.text}</span>
                    </a> <br/>
                    <span class="font-size-sm">
                          Handled By <span class="font-weight-bolder">${row.ASSIGNED_COUNSELLOR}</span>
                    </span>`;
            }
          },
        },
        {
          field: 'SCHOOL',
          title: 'School',
          width: 170,
          template: function (row) {
            return `<span class="font-size-sm font-weight-bolder" > ${row.SCHOOL == null ? '-' : row.SCHOOL}</span><br/>
                  <span class="font-size-sm text-muted">${row.GRADE == null ? '-' : row.GRADE}</span>`;
          },
        },
        {
          field: 'LEADS',
          title: 'Score',
          textAlign: 'center',
          width: 95,
          template: function (row) {
            let statusLabel, statusString;

            switch (row.LEADS) {
              case '1':
                statusLabel = 'Cold';
                statusString = ' label-light-success';
                break;
              case '2':
                statusLabel = 'Warm';
                statusString = ' label-light-warning';
                break;
              case '3':
                statusLabel = 'Hot';
                statusString = ' label-light-danger';
                break;
              default:
                statusLabel = 'Unranked';
                statusString = ' label-light-secondary text-dark';
            }

            return `<span class="label label-sm font-weight-bold ${statusString} label-inline" > ${statusLabel}</span> `;
          },
        },
        {
          field: 'NOTES',
          title: 'Consultation',
          textAlign: 'center',
          sortable: false,
          template: function (row) {
            if (row.NOTES == '' || row.NOTES == null) {
              return '';
            }

            if (row.NOTES.length >= 25) {
              return `<span class="font-size-sm font-weight-bolder text-hover-primary consultation-popover" data-toggle="popover" data-trigger="hover" title="Consultation Details" data-content="${row.NOTES}">${row.NOTES.substring(0, 25)} ... </span>`;
            } else {
              return `<span class="font-size-sm">${row.NOTES}</span>`;
            }
          },
        },
        {
          field: 'TIME',
          title: 'Duration',
          textAlign: 'center',
          sortable: false,
          template: function (row) {
            if (row.TIME === null || row.TIME === '') {
              return '';
            } else {
              return `<span class="font-size-sm">${row.TIME}</span>`;
            }
          },
        },
        {
          field: 'ACT',
          title: 'Last Follow Up',
          sortable: false,
          template: function (row) {
            if (row.ACT == '' || row.ACT == null) {
              return '';
            }

            if (row.ACT.length >= 25) {
              return `<span class="font-size-sm font-weight-bolder text-hover-primary consultation-popover" data-toggle="popover" data-trigger="hover" title="Consultation Details" data-content="${row.ACT}">${row.ACT.substring(0, 25)} ... </span>
                    <br/>on <span class="font-size-sm font-weight-bolder">${row.LAST_ACT}</span>`;
            } else {
              return `<span class="font-size-sm">${row.ACT}</span>
                    <br/>on <span class="font-size-sm font-weight-bolder">${row.LAST_ACT}</span>`;
            }
          },
        },
      ],
    });
};

const seminarSubtable = (e) => {
  $('<div/>')
    .attr('id', 'child_data_ajax_' + e.data.SESS_ID)
    .appendTo(e.detailCell)
    .KTDatatable({
      data: {
        type: 'remote',
        source: {
          read: {
            url: BASE_URL + 'C_Event/getSeminarStudentList',
            params: {
              session: e.data.SESS_ID,
              scheduleID: getUrlParameter('id'),
            },
          },
        },
        pageSize: 5,
        serverPaging: false,
        serverFiltering: false,
        serverSorting: false,
      },
      layout: {
        scroll: false,
        footer: false,
        spinner: {
          type: 1,
          theme: 'default',
        },
      },
      pagination: true,
      sortable: true,
      columns: [
        {
          field: 'NAME',
          title: 'Student',
          width: 240,
          template: function (row) {
            if (row.STATUS === null) {
              return `
                <ul class="list-unstyled">
                  <li>
                    <span class="fw-bolder text-dark text-hover-primary font-size-sm">
                      ${row.NAME}
                    </span>
                    ${row.VIP_CHECK == 'YES' ? '<span class="label label-sm label-inline label-danger fw-bolder">VIP</span>' : ''}
                  </li>
                  <li>
                    <span class="font-size-sm">
                      ${row.ASSIGNED_COUNSELLOR === null || row.ASSIGNED_COUNSELLOR === 'NONE' ? 'Unhandled' : 'Handled By'} 
                      ${row.ASSIGNED_COUNSELLOR === null || row.ASSIGNED_COUNSELLOR === 'NONE' ? '' : row.ASSIGNED_COUNSELLOR}
                    </span>
                  </li>
                </ul>
              `;
            } else {
              const statObj = {
                class: null,
                text: null,
              };

              switch (row.STATUS) {
                case 'ACTIVE':
                  statObj.text = 'ACTIVE';
                  statObj.class = ' label-light-success';
                  break;

                case 'INACTIVE':
                case 'CANCEL':
                  statObj.text = 'INACTIVE';
                  statObj.class = ' label-light-danger';
                  break;

                case 'CLOSED':
                case 'COMPLETE':
                  statObj.text = 'CLOSED';
                  statObj.class = ' label-light-warning';
                  break;

                case 'FINISHED':
                  statObj.text = 'FINISHED';
                  statObj.class = ' label-light-info';
                  break;

                case 'OPEN':
                  statObj.text = 'OPEN';
                  statObj.class = ' ';
                  break;
              }

              return `
                <ul class="list-unstyled">
                  <li>
                    <a class="fw-bolder text-dark text-hover-primary font-size-sm" href="${row.STATUS != null ? BASE_URL + 'detail_student?id=' + row.ID : '#'}">
                      ${row.NAME} <span class="ml-3 label label-sm fw-bold ${statObj.class} label-inline" > ${statObj.text}</span>
                      ${row.VIP_CHECK == 'YES' ? '<span class="label label-sm label-inline label-danger fw-bolder">VIP</span>' : ''}
                    </a>
                  </li>
                  <li>
                    <span class="font-size-sm">
                      Handled By <span class="fw-bolder">${row.ASSIGNED_COUNSELLOR}</span>
                    </span>
                  </li>
                </ul>
              `;
            }
          },
        },
        {
          field: 'SCHOOL',
          title: 'School',
          width: 170,
          template: function (row) {
            return `<span class="font-size-sm font-weight-bolder" > ${row.SCHOOL == null ? '-' : row.SCHOOL}</span><br/>
                  <span class="font-size-sm text-muted">${row.GRADE == null ? '-' : row.GRADE}</span>`;
          },
        },
        {
          field: 'ACT',
          title: 'Last Follow Up',
          sortable: false,
          template: function (row) {
            if (row.ACT == '' || row.ACT == null) {
              return '';
            }

            if (row.ACT.length >= 25) {
              return `<span class="font-size-sm font-weight-bolder text-hover-primary consultation-popover" data-toggle="popover" data-trigger="hover" title="Consultation Details" data-content="${row.ACT}">${row.ACT.substring(0, 25)} ... </span>
                    <br/>on <span class="font-size-sm font-weight-bolder">${row.LAST_ACT}</span>`;
            } else {
              return `<span class="font-size-sm">${row.ACT}</span>
                    <br/>on <span class="font-size-sm font-weight-bolder">${row.LAST_ACT}</span>`;
            }
          },
        },
      ],
    });
};

const consultantList = $('#consultationTable').KTDatatable({
  data: {
    type: 'remote',
    source: {
      read: {
        url: BASE_URL + 'Expo/getConsultationList?id=' + getUrlParameter('id'),
        map: function (raw) {
          $('#totalBooth').html('(' + raw.length + ')');

          let dataSet = raw;

          if (typeof raw.data !== 'undefined') {
            dataSet = raw.data;
          }

          return dataSet;
        },
      },
    },
    pageSize: 10,
    serverPaging: false,
    serverFiltering: true,
    serverSorting: false,
  },
  layout: {
    scroll: false,
    footer: false,
  },
  detail: {
    title: 'View Consultation Details',
    content: consultationSubtable,
  },
  search: {
    input: $('#consultationSearch'),
    key: 'generalSearch',
    delay: 500,
  },
  sortable: true,
  pagination: true,
  columns: [
    {
      field: 'UNI_ID',
      title: '',
      sortable: false,
      width: 30,
      textAlign: 'center',
    },
    {
      field: 'UNI_NAME',
      title: 'University Name',
      type: 'text',
      width: 165,
      template: function (row) {
        return `<span class="font-weight-bolder font-size-sm">
                  ${row.UNI_NAME}
                </span> `;
      },
    },
    {
      field: 'VISITOR',
      title: 'Total Visitor',
      type: 'text',
      template: function (row) {
        return `<span class="font-weight-bolder font-size-sm">
                  ${row.VISITOR}
                </span> `;
      },
    },
    {
      field: 'AVG_DURATION',
      title: 'AVerage Duration',
      type: 'text',
      template: function (row) {
        return `<span class="font-size-sm" >
                  <strong class="${row.AVG_DURATION === '' ? 'text-danger' : ''}">${row.AVG_DURATION == '' ? '-' : row.AVG_DURATION}</strong>
                </span> `;
      },
    },
    {
      field: 'HOT_LEADS',
      title: 'Hot Leads',
      type: 'text',
      template: function (row) {
        const curPercentage = row.HOT_LEADS / row.VISITOR;

        return `<span class="font-size-sm">
                  ${row.HOT_LEADS == null ? '0' : row.HOT_LEADS} <strong>(${Math.round(curPercentage * 100)}%)</strong>
                </span> `;
      },
    },
    {
      field: 'WARM_LEADS',
      title: 'Warm Leads',
      type: 'text',
      template: function (row) {
        const curPercentage = row.WARM_LEADS / row.VISITOR;

        return `<span class="font-size-sm" >
                  ${row.WARM_LEADS == null ? '0' : row.WARM_LEADS} <strong>(${Math.round(curPercentage * 100)}%)</strong>
                 </span> `;
      },
    },
    {
      field: 'COLD_LEADS',
      title: 'Cold Leads',
      type: 'text',
      template: function (row) {
        const curPercentage = row.COLD_LEADS / row.VISITOR;

        return `<span class="font-size-sm" >
                  ${row.COLD_LEADS == null ? '0' : row.COLD_LEADS} <strong>(${Math.round(curPercentage * 100)}%)</strong>
                </span> `;
      },
    },
    {
      field: 'UNRANKED_LEADS',
      title: 'No Score',
      type: 'text',
      template: function (row) {
        const curPercentage = row.UNRANKED_LEADS / row.VISITOR;

        return `<span class="font-size-sm ${row.UNRANKED_LEADS != null && row.UNRANKED_LEADS > 0 ? 'text-danger' : ''}" >
                  ${row.UNRANKED_LEADS == null ? '0' : row.UNRANKED_LEADS} <strong>(${Math.round(curPercentage * 100)}%)</strong>
                </span> `;
      },
    },
    {
      field: '',
      title: 'Action',
      type: 'button',
      template: function (row) {
        return `<button class="btn btn-light-warning btn-export-consultations" data-name="${row.UNI_NAME}" data-id="${row.EVENT_ID}" data-uni="${row.UNI_ID}" > Export</button> `;
      },
    },
  ],
});

const seminarList = $('#seminarTable').KTDatatable({
  data: {
    type: 'remote',
    source: {
      read: {
        url: BASE_URL + 'C_Event/getSeminarList?id=' + getUrlParameter('id'),
        map: function (raw) {
          let dataSet = raw;

          if (typeof raw.data !== 'undefined') {
            dataSet = raw.data;
          }

          $('#totalSeminar').html(`(${raw.total})`);

          return dataSet;
        },
      },
    },
    pageSize: 10,
    serverPaging: false,
    serverFiltering: false,
    serverSorting: false,
  },
  detail: {
    title: 'View Seminar Details',
    content: seminarSubtable,
  },
  layout: {
    scroll: false,
    footer: false,
  },
  sortable: true,
  pagination: true,
  columns: [
    {
      field: 'SESS_ID',
      title: '',
      sortable: false,
      width: 30,
      textAlign: 'center',
    },
    {
      field: 'SESS_TITLE',
      title: 'Seminar',
      type: 'text',
      width: 250,
      sortable: false,
      template: function (row) {
        let curSess = '';

        switch (row.SESS_ID) {
          case 'Seminarsatu':
            curSess = 'Session One';
            break;

          case 'Seminardua':
            curSess = 'Session Two';
            break;

          case 'Seminartiga':
            curSess = 'Session Three';
            break;
        }

        return `<span class="font-weight-bolder font-size-sm">${row.SESS_TITLE}</span> <br/>
                <span class="text-muted font-weight-bold">${curSess} - ${row.SESS_TIME}</span>`;
      },
    },
    {
      field: 'SESS_REGISTERED',
      title: 'Registered',
      type: 'text',
      width: 150,
      sortable: false,
      template: function (row) {
        return `<span class="font-weight-bolder text-center">${row.SESS_REGISTERED}</span>`;
      },
    },
    {
      field: 'SESS_ATTENDANCE',
      title: 'Attendance',
      type: 'text',
      width: 250,
      sortable: false,
      template: function (row) {
        return `<span class="font-weight-bolder text-center">${row.SESS_ATTENDANCE}</span>`;
      },
    },
    {
      field: '',
      title: 'Action',
      type: 'text',
      width: 250,
      sortable: false,
      template: function (row) {
        return `<button class="btn btn-light-warning btn-seminar-action" data-action="EDIT" data-name="${row.SESS_TITLE}" data-id="${row.ID}" data-schedule="${getUrlParameter('id')}" data-session="${row.SESS_ID}" data-time="${row.SESS_TIME}">Edit</button> 
                <button class="btn btn-light-danger btn-seminar-action ml-3" data-action="DELETE" data-schedule="${getUrlParameter('id')}" data-id="${row.ID}" data-session="${row.SESS_ID}">Delete</button>`;
      },
    },
  ],
});

const participantList = $('#participantsTable').KTDatatable({
  data: {
    type: 'remote',
    source: {
      read: {
        url: BASE_URL + 'Expo_Packages/getParticipants?id=' + getUrlParameter('id'),
        params: {
          type: 'list',
          id: $('[name="eventID"]').val(),
        },
        map: function (raw) {
          $('#totalparticipants').html('(' + raw.length + ')');

          var dataSet = raw;

          if (typeof raw.data !== 'undefined') {
            dataSet = raw.data;
          }

          return dataSet;
        },
      },
    },
    pageSize: 10,
    serverPaging: false,
    serverFiltering: true,
    serverSorting: false,
  },
  layout: {
    scroll: false,
    footer: false,
  },
  sortable: true,
  pagination: true,
  columns: [
    {
      field: 'NAME',
      title: 'Student Name',
      type: 'text',
      width: 225,
      template: function (row) {
        return `
          <ul class="list-unstyled">
            <li>
              <span class="fw-bolder font-size-sm">
                ${row.NAME} 
                ${row.VIP_CHECK == 'YES' ? '<span class="label label-sm label-inline label-danger fw-bolder">VIP</span>' : ''}
                <i class="fa fas fa-star attendance-popover text-warning ${row.ATT_STATUS != 'ATTENDED' ? 'd-none' : ''}" data-toggle="popover" data-content="Attended Event"></i>
              </span>
            </li>
            <li>
              <span class="fw-bold text-muted text-hover-primary">${row.SCHOOL === null ? '(NO DATA)' : row.SCHOOL} - ${row.GRADE}</span>
            </li>
          </ul>
        `;
      },
    },
    {
      field: 'STATUS',
      title: 'Status',
      type: 'text',
      template: function (row) {
        let curObj = {
          text: null,
          class: null,
        };

        switch (row.STATUS) {
          case 'OPEN':
            curObj.text = 'Open';
            curObj.class = '';
            break;

          case 'INACTIVE':
          case 'CANCEL':
          case 'CANCELED':
            curObj.text = 'Inactive';
            curObj.class = 'label-light-danger';
            break;

          case 'ARCHIVED':
            curObj.text = 'Archived';
            curObj.class = 'label-light-success';
            break;

          case 'UNHANDLED':
            curObj.text = 'Unasigned';
            curObj.class = 'label-light-danger';
            break;

          case 'CLOSED':
            curObj.text = 'Closed';
            curObj.class = 'label-light-warning';
            break;

          case 'ACTIVE':
            curObj.text = 'Active';
            curObj.class = 'label-light-success';
            break;
        }

        if (curObj.class == null) {
          return ``;
        } else {
          return `<span class="ml-3 label label-inline font-weight-bold label-lg ${curObj.class} ">${curObj.text}</span>`;
        }
      },
    },
    {
      field: 'COUNSELLOR',
      title: 'Handled By',
      width: 195,
      template: function (row) {
        return `<span class="font-weight-bolder font-size-lg">
                    ${row.COUNSELLOR === null ? 'Unhandled' : row.COUNSELLOR}
                </span>`;
      },
    },
    {
      field: 'TYPE',
      title: 'Type',
      width: 90,
      template: function (row) {
        let curLabel, curClass, curText;

        if (row.TYPE == 'REGISTERED') {
          curLabel = 'text-warning';
          curClass = 'label-warning';
          curText = 'Registered';
        } else {
          curLabel = 'text-warning';
          curClass = 'label-warning';
          curText = 'Invited';
        }

        return `<span class="label ${curClass} label-dot mr-2"></span>
                <span class="font-weight-bold ${curLabel}">${curText}</span>`;
      },
    },
    {
      field: 'BRANCH',
      title: 'Branch',
      type: 'text',
      width: 120,
      template: function (row) {
        return `<span class="label label-lg font-weight-bold label-inline label-light-success">
                            ${row.BRANCH}
                        </span>`;
      },
    },
    {
      field: '',
      title: 'Action',
      type: 'button',
      width: 195,
      template: function (row) {
        if (['OPEN', 'INACTIVE', 'CANCEL', 'CANCELED', 'CLOSED', 'ACTIVE'].includes(row.STATUS)) {
          return `<div class="d-flex">
                      <a href="${BASE_URL + 'detail_student?id=' + row.STUDENT_ID}" target="_blank" class="btn btn-sm btn-light-success mr-5">Show Details</a>
                      <button class="btn btn-sm btn-light-danger btn-remove-student ${row.STUDENT_ID != null ? 'd-none' : ''} " data-id="${row.STUDENT_ID}" type="button">Remove</button>
                  </div>`;
        } else {
          return '';
        }
      },
    },
  ],
});

/** Initialize component */
const initParticipants = function () {
  initTimePicker('[name="seminarTime"]');

  /** Consultation Popover Setup */
  $('#consultationTable')
    .on('mouseenter', '.consultation-popover', function () {
      $(this)
        .popover({
          container: 'body', // Specify the container where the popover should be appended to
        })
        .popover('show');
    })
    .on('mouseleave', '.consultation-popover', function () {
      $(this).popover('hide');
    });
};

const participantListener = () => {
  /** Table Listener */
  if ($('#consultationTable').length > 0) {
    consultantList.on('datatable-on-ajax-fail', function () {
      KTApp.unblock('#consultation-tab');

      Swal.fire({
        html: 'Cannot load Deposit Table! Please try again later',
        icon: 'error',
        confirmButtonText: 'Close',
        showCancelButton: false,
      });
    });

    consultantList.on('datatable-on-ajax-done', function () {
      KTApp.unblock('#consultation-tab');
    });
  }

  if ($('#seminarTable').length > 0) {
    seminarList.on('datatable-on-ajax-fail', function () {
      KTApp.unblock('#consultation-tab');

      Swal.fire({
        html: 'Cannot load Seminar Table! Please try again later',
        icon: 'error',
        confirmButtonText: 'Close',
        showCancelButton: false,
      });
    });

    seminarList.on('datatable-on-ajax-done', function () {
      KTApp.unblock('#consultation-tab');
    });
  }

  if ($('#participantsTable').length > 0) {
    participantList.on('datatable-on-ajax-fail', function (e, errResp) {
      KTApp.unblock('#consultation');

      if (errResp.responseJSON.code == 123) {
        //   Swal.fire({
        //     html: "Event Form ID is required.",
        //     icon: "warning",
        //     confirmButtonText: "Close",
        //     showCancelButton: false,
        //   });
      } else {
        Swal.fire({
          html: 'Cannot load Participant Table! Please try again later',
          icon: 'error',
          confirmButtonText: 'Close',
          showCancelButton: false,
        });
      }
    });

    participantList.on('datatable-on-ajax-done', function () {
      KTApp.unblock('#consultation');
    });
  }

  /** Export Participant */
  $('#exportParticipants').on('click', function () {
    KTApp.block('#consultation', {
      opacity: 0.1,
      state: 'primary',
      message: 'Compiling Data...',
    });

    $.ajax({
      url: BASE_URL + 'Expo_Packages/exportParticipants?id=' + getUrlParameter('id'),
      data: {
        id: $('[name="eventID"]').val(),
        'query[TYPE]': $('#filterParticipantsTable').val(),
      },
      method: 'POST',
      xhrFields: {
        responseType: 'blob',
      },
      success: function (data) {
        Swal.fire({
          html: 'Data Exported!',
          icon: 'success',
          showCancelButton: false,
          confirmButtonText: 'Close',
        });

        const curFile = `${$('[name="nama_event"]').val()} Participant Report.xlsx`;

        const a = document.createElement('a');
        const url = window.URL.createObjectURL(data);

        a.href = url;
        a.download = curFile;
        document.body.append(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);

        KTApp.unblock('#consultation');
      },
      error: function (data) {
        Swal.fire({
          title: 'Network Problem Detected!',
          html: 'Cannot create file, please try again later!',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'Close',
        });

        KTApp.unblock('#consultation');
      },
    });
  });
  /** EoL Export Participant */

  /** Seminar Listener */
  const postSeminarData = function (obj) {
    return $.post(BASE_URL + 'C_Event/postSeminar?id=' + getUrlParameter('id'), obj);
  };

  $('#formAddSeminar').on('submit', function (evt) {
    evt.preventDefault();

    KTApp.block('#modalAddSeminar', {
      opacity: 0.1,
      state: 'primary',
      message: 'Please wait...',
    });

    postSeminarValidation.validate().then(function (status) {
      if (status != 'Valid') {
        KTApp.unblock('#modalAddSeminar');
        return;
      }

      const sessVal = $('#modalAddSeminar [name="seminarSession"]');
      const titleVal = $('#modalAddSeminar [name="seminarTitle"]');
      const timeVal = $('#modalAddSeminar [name="seminarTime"]');
      const curAction = $('#modalAddSeminar [name="seminarFormAction"]');
      const curID = $('#modalAddSeminar [name="seminarFormID"]');

      postSeminarData({
        seminarSession: sessVal.val(),
        seminarTitle: titleVal.val(),
        seminarTime: timeVal.val(),
        action: curAction.val(),
        id: curID.val(),
      })
        .done((res) => {
          if (res.code === 204) {
            Swal.fire({
              html: `<strong>${sessVal.find(':selected').text()}</strong> Already Exist. <br/>Do you want to replace it?`,
              icon: 'question',
              showCancelButton: true,
              cancelButtonText: 'Cancel',
              confirmButtonText: 'Replace',
            }).then((btnRes) => {
              if (btnRes.isConfirmed) {
                postSeminarData({
                  seminarSession: sessVal.val(),
                  seminarTitle: titleVal.val(),
                  seminarTime: timeVal.val(),
                  bypassOverwrite: 'YES',
                }).always(() => {
                  Swal.fire({
                    html: `Seminar session replaced`,
                    icon: 'success',
                    showCancelButton: false,
                    confirmButton: 'Close',
                  });

                  KTApp.unblock('#modalAddSeminar');
                });
              } else {
                KTApp.unblock('#modalAddSeminar');
              }
            });
          } else if (res.code === 200) {
            Swal.fire({
              html: `Seminar session created`,
              icon: 'success',
              showCancelButton: false,
              confirmButton: 'Close',
            });

            seminarList.reload();
            $('#modalAddSeminar').modal('hide');

            $('#modalAddSeminar [name="seminarTitle"]').val(null);
            $('#modalAddSeminar [name="seminarFormAction"]').val('CREATE');
            $('#modalAddSeminar [name="seminarSession"]').val(null).selectpicker('refresh');

            KTApp.unblock('#modalAddSeminar');
          }
        })
        .fail((err) => {
          console.log(err);

          console.log('something wrong happen');
          KTApp.unblock('#modalAddSeminar');
        });
    });
  });

  $(document).on('click', '.btn-seminar-action', function () {
    const curBtn = $(this);

    KTApp.block('#consultation', {
      overlayColor: '#ffffff',
      type: 'loader',
      state: 'primary',
      opacity: 0.3,
      size: 'lg',
    });

    if (curBtn.attr('data-action') == 'DELETE') {
      Swal.fire({
        html: 'Are you sure you want to delete this session?<br/>This process <strong>cannot be reversed</strong> and might cause participant issues',
        icon: 'question',
        showCancelButton: true,
        cancelButtonText: 'Close',
        confirmButtonText: 'Delete',
      }).then((res) => {
        if (!res.isConfirmed) {
          KTApp.unblock('#consultation');
          return;
        }

        // Hapus list-nya
        $.post(
          BASE_URL + 'C_Event/removeSeminarSession?id=' + curBtn.attr('data-schedule'),
          {
            id: curBtn.attr('data-id'),
          },
          function (resp) {
            if (resp.code != 200) {
              Swal.fire({
                html: '<strong>Cannot delete session</strong>, please try again later',
                icon: 'warning',
                focusConfirm: false,
                showCancelButton: false,
                confirmButtonText: 'Close',
              });

              return;
            }

            Swal.fire({
              html: '<strong>Session Removed</strong> successfully',
              icon: 'success',
              focusConfirm: false,
              showCancelButton: false,
              confirmButtonText: 'Close',
            });

            seminarList.reload();
            KTApp.unblock('#consultation');
          }
        );
      });
    } else if (curBtn.attr('data-action') == 'EDIT') {
      // Buka modal Add buat edit data-nya
      $('#modalAddSeminar #labelAddSeminar').html('Edit Seminar');

      $('#modalAddSeminar [name="seminarTitle"]').val(curBtn.attr('data-name'));
      $('#modalAddSeminar [name="seminarFormID"]').val(curBtn.attr('data-id'));
      $('#modalAddSeminar [name="seminarSession"]').val(curBtn.attr('data-session')).selectpicker('refresh');

      $('#modalAddSeminar [name="seminarFormAction"]').val('UPDATE');

      // Split time
      const curTime = curBtn.attr('data-time').split(' - ');

      $('#modalAddSeminar [name="seminarTime"]')
        .daterangepicker({
          timePicker: true,
          timePicker24Hour: true,
          timePickerIncrement: 5,
          startDate: curTime[0],
          endDate: curTime[1],
          locale: { format: 'HH:mm', cancelLabel: 'Clear' },
          buttonClasses: ' btn',
          applyClass: 'btn-primary',
          cancelClass: 'btn-secondary',
        })
        .on('show.daterangepicker', function (ev, picker) {
          picker.container.find('.ranges').hide();
          picker.container.find('.calendar-table').hide();
        });

      KTApp.unblock('#consultation');

      $('#modalAddSeminar').modal('show');
    }
  });

  /** Participant listener */
  $('#participantSearch').on('keydown', function (e) {
    if (e.key === 'Enter' || e.keyCode === 13) {
      e.preventDefault();

      const curVal = $(this).val();

      KTApp.block('#consultation', {
        opacity: 0.1,
        state: 'primary',
        message: 'Compiling Data...',
      });

      participantList.search(curVal, 'GENERAL');
    }
  });

  $('#filterParticipantsTable').on('change', function () {
    const curVal = $(this).val();

    KTApp.block('#consultation', {
      opacity: 0.1,
      state: 'primary',
      message: 'Compiling Data...',
    });

    participantList.search(curVal, 'TYPE');
  });
};

export { initParticipants, consultantList, seminarList, participantListener, participantList };
